import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome5-pro-styles',
	templateUrl:'./FontAwesome5ProStylesPluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesome5ProStylesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesome5ProStylesPluginCompPage
{
	mdContent_924 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5pro.FontAwesome5ProStyles;
\`\`\``;
}
